import { Component, computed, input, signal } from '@angular/core';
import { IFilter } from '../../interfaces';
import { NHAPopupComponent } from '@nha/components/popup';
import { CommonModule } from '@angular/common';
import { NHAChipComponent } from '@nha/components/chip';
import { NHAFilterChipContentComponent } from '../filter-chip-content/filter-chip-content.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'nha-filter-chip-group',
	standalone: true,
	imports: [CommonModule, NHAPopupComponent, MatIconModule, MatButtonModule, MatTooltipModule, NHAChipComponent, NHAFilterChipContentComponent],
	templateUrl: './filter-chip-group.component.html',
	styleUrls: ['./filter-chip-group.component.scss']
})
export class NHAFilterChipGroupComponent {
	key = input.required<string>();
	groupTitle = input.required<string>();
	filters = input.required<{ value: IFilter; key: string }[]>();
	counts = input<boolean>(false);

	popupOpen = signal<boolean>(false);

	isSelected = computed(() => this.filters().some((x) => x.value.items.some((i) => i.selected)));
	filterTitle = computed(() => {
		const groupTitle = this.groupTitle();
		const selectedFilters = this.filters().filter((x) => x.value.items.some((i) => i.selected));

		if (selectedFilters.length === 1) {
			return groupTitle + ': ' + selectedFilters[0].value.title;
		}

		if (selectedFilters.length > 1) {
			return groupTitle + `: ${selectedFilters.length} selected`;
		}

		return groupTitle;
	});
}
